module.exports = __webpack_public_path__ + "img/cert13x.43163b29.png";